import { render, staticRenderFns } from "./ReviewSubmissionModal.vue?vue&type=template&id=79103d50&scoped=true"
import script from "./ReviewSubmissionModal.vue?vue&type=script&lang=js"
export * from "./ReviewSubmissionModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewSubmissionModal.vue?vue&type=style&index=0&id=79103d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79103d50",
  null
  
)

export default component.exports